import alt from '../alt';
import modalAction from './modalAction';

class employeeAction {
    constructor() {
        this.generateActions(
            'warningMsg',
            'processing',
            'search',
            'displayDetail',
            'staffId',
            'userDetailSuccess',
            'employeeSuccess',
            'clear'
        );
    }
    getEmployee() {

        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/employee/all', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        let result = JSON.parse(xhttp.responseText);
                        this.employeeSuccess(result);
                    } else {
                        //handle error
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        this.processing(false);
        return true;
    }
    userDetail(staffId) {

        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("GET", '/v1/api/employee/' + staffId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    let result = JSON.parse(xhttp.responseText);
                    if (xhttp.status == 200) {
                        this.userDetailSuccess(result);
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Message", content: result.errorMsg });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }

        return true;
    }
    getEmployeeExport(staffId) {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/export/employee/' + staffId, true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.responseType = "arraybuffer";
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        var blobUrl = URL.createObjectURL(blob);
                        var link = document.createElement("a"); // Or maybe get it from the current document
                        link.href = blobUrl;
                        link.download = "EmployeeProfile_" + staffId + ".xlsx";
                        document.body.appendChild(link); // Or append it whereever you 
                        link.click();
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went", content: "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        return true;
    }
    exportProfile() {
        if (sessionStorage.getItem('ui')) {
            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", '/v1/api/export/employee', true);
            xhttp.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem('ui'));
            xhttp.responseType = "arraybuffer";
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4) {
                    if (xhttp.status == 200) {
                        var blob = new Blob([xhttp.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        var blobUrl = URL.createObjectURL(blob);
                        var link = document.createElement("a"); // Or maybe get it from the current document
                        link.href = blobUrl;
                        link.download = "EmployeeProfile_All.xlsx";
                        document.body.appendChild(link); // Or append it whereever you 
                        link.click();
                    } else {
                        //handle error
                        modalAction.modalContent({ title: "Something went", content: "Please contact admin" });
                        modalAction.modalClose(true);
                    }
                    this.processing(false);
                }
            };
            xhttp.send(null);
        }
        return true;
    }
}
export default alt.createActions(employeeAction);


// WEBPACK FOOTER //
// ./app/actions/employeeAction.js